<template>
  <div class="f360-vc-banner-educa">
    <div class="content-left">
      <img style="" class="hidden-sm-and-down" :src="logo" alt="logo" />
      <span>
        <b> Tem 2 minutos?</b> Responda a pesquisa e nos ajude a turbinar sua
        gestão financeira!
      </span>
    </div>
    <div class="content-right">
      <el-button class="banner-button" @click="handleLink">
        <span class="banner-button__label">
          Participar agora
          <MaterialIcon class="banner-button__icon" icon="arrow_outward" />
        </span>
      </el-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import logo from "@/ui/assets/f360-icon-purple.png";
import MaterialIcon from "@/ui/components/Icons/MaterialIcon/MaterialIcon.vue";

const handleLink = () => {
  window.open("https://forms.gle/GwPKuoPMuEnNkCKm6", "_blank");
};
</script>

<style lang="scss" scoped>
@use "@/ui/styles/theme/f360-theme" as *;
@use "@/ui/styles/variables" as *;

.f360-vc-banner-educa {
  font-family: $fontFamily;
  width: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background-color: _map.get($map: $roxo, $key: 300);
  border-radius: 0.3125rem;
  color: #2e2e2e;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.3125rem;

  .content-left {
    display: flex;
    align-items: center;

    img {
      margin-right: 8px;
      height: auto;
    }
  }

  .content-right {
    display: flex;
    align-items: center;

    .left-title {
      padding-right: 8px;
    }

    p {
      margin-right: 8px;
    }
  }

  .banner-button {
    height: 32px;
    padding: 0 5px;
    border-radius: 5px;
    border: 1px solid #e7e7e7;
    padding: 4px 8px 4px 8px;
    gap: 8px;
    background-color: #fff;
    color: _map.get($map: $roxo, $key: 500);
    cursor: pointer;

    &__label {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 3px;

      font-family: $fontFamily;
      font-weight: 600;
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -3%;

      &--small {
        display: flex;
        justify-content: center;
        font-size: 12px;
        line-height: 10px;
        margin-left: 8px;
      }
    }

    &__icon {
      font-size: 16px;
    }

    @media (min-width: 768px) and (max-width: 1200px) {
      .display-btn-text {
        display: none;
      }
    }
  }

  .banner-button:hover {
    color: _map.get($map: $roxo, $key: 300);
  }

  @media screen and (max-width: 768px) {
    display: flex;
    flex-direction: column;
    height: auto;

    .content-left {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 100%;

      img {
        margin-right: 15px;
        margin-top: 0px;
      }

      p {
        text-align: left;
        text-indent: 10px;
        text-align: justify;
      }
    }

    .content-right {
      display: flex;
      flex-direction: row;
      align-items: left;
      justify-content: left;
      width: 100%;
      margin: 1rem 0 0 0;

      p {
        text-align: left;
      }
    }
  }
}
</style>
